import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "grid gap-5 md:grid-cols-2"
}
const _hoisted_3 = {
  key: 1,
  class: "grid gap-5 md:grid-cols-2"
}
const _hoisted_4 = {
  key: 2,
  class: "flex flex-col space-y-4"
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 3,
  class: "flex flex-col space-y-4"
}
const _hoisted_7 = { class: "mx-auto text-muted" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1 mt-4 mb-12 bg-gray-200 rounded-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExerciseSearchFilters = _resolveComponent("ExerciseSearchFilters")!
  const _component_MinimalExercisePreview = _resolveComponent("MinimalExercisePreview")!
  const _component_MinimalExercisePreviewSkeleton = _resolveComponent("MinimalExercisePreviewSkeleton")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_VueEternalLoading = _resolveComponent("VueEternalLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ExerciseSearchFilters, {
      class: "px-8 pt-6 pb-2 mb-6 -mx-4 md:-mx-8 bg-light",
      modelValue: _ctx.searchFilter,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilter) = $event)),
      onResetFilters: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchFilter = _ctx.getBlankExerciseSearchFilters())),
      full: false
    }, null, 8, ["modelValue"]),
    (!_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.exercises, (exercise, index) => {
            return (_openBlock(), _createBlock(_component_MinimalExercisePreview, {
              selectable: true,
              selectionDisabled: 
					_ctx.isExerciseDraft(exercise) || _ctx.isSelectedInAnotherRule(exercise)
				,
              selectButtonTitle: 
					_ctx.isExerciseDraft(exercise)
						? _ctx.$t('exercise_picker.cannot_pick_draft')
						: _ctx.isSelectedInAnotherRule(exercise)
						? _ctx.$t('exercise_picker.already_selected')
						: ''
				,
              key: 'course-' + _ctx.courseId + '-exercise-' + index,
              exercise: exercise,
              onSelection: ($event: any) => (_ctx.onSelection(exercise)),
              highlighted: _ctx.isSelected(exercise)
            }, null, 8, ["selectionDisabled", "selectButtonTitle", "exercise", "onSelection", "highlighted"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_MinimalExercisePreviewSkeleton),
          _createVNode(_component_MinimalExercisePreviewSkeleton),
          _createVNode(_component_MinimalExercisePreviewSkeleton),
          _createVNode(_component_MinimalExercisePreviewSkeleton),
          _createVNode(_component_MinimalExercisePreviewSkeleton),
          _createVNode(_component_MinimalExercisePreviewSkeleton)
        ])),
    (!_ctx.firstLoading && _ctx.mainStore.exercises.length === 0 && _ctx.emptyFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("exercise_picker.no_available_exercises")), 1),
          _createVNode(_component_router_link, {
            class: "mx-auto link",
            to: { name: 'CourseExercises' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Btn, { variant: 'primary-borderless' }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("exercise_picker.go_to_exercises")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (!_ctx.firstLoading && _ctx.mainStore.exercises.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("course_exercises.no_matching_exercises")) + ". ", 1),
            _createVNode(_component_router_link, {
              class: "mx-auto link",
              to: { name: 'CourseExercises' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Btn, { variant: 'primary-borderless' }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("exercise_picker.go_to_exercises")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_VueEternalLoading, {
      load: _ctx.onLoadMore,
      "is-initial": _ctx.isInitialInfiniteLoad,
      "onUpdate:is-initial": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isInitialInfiniteLoad) = $event))
    }, {
      loading: _withCtx(() => [
        _createVNode(_component_Spinner)
      ]),
      "no-more": _withCtx(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["load", "is-initial"])
  ]))
}